import React from "react";
import { useLocation } from "react-router-dom";

import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import splashBackground from "../../assets/images/signIn-splash-screen.svg";
import {
  colors,
  fontFamily,
  hvCenter,
  pxtorem,
} from "../../assets/styles/theme";
import { Box, Button, Link } from "@mui/material";

import logoBlue from "../../assets/images/2060Digital-logo-blue.svg";
import Alert from "@mui/material/Alert";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const HomeSignInSplashScreen = styled.div`
  height: calc(100% + 60px);
  margin-top: -60px;
  ${hvCenter};
  flex-direction: column;
  background: radial-gradient(at center, #fff 46.38%, #cdcdcd 100%);
  .splashBg {
    margin-top: -60px;
    width: 100%;
    max-width: 740px;
    height: 100%;
    max-height: 580px;
    background-image: url(${splashBackground});
    background-size: contain;
    background-repeat: no-repeat;
    .link-splash {
      margin: 46.5% 0 0 46%;
    }
  }
  .txt-copyright {
    font-family: ${fontFamily.karla};
    font-size: ${pxtorem(10)};
    color: ${colors.primaryDark};
    line-height: 11.69px;
    position: absolute;
    bottom: 20px;
  }
`;

const Error = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const message = location.state;

  const redirectToHome = () => {
    console.log("redirectToHome");
    navigate("/")
  }

  return (
    <>
      <HomeSignInSplashScreen>
        <Box>
          <img
            src={logoBlue}
            alt="2060 Digital Logo"
            style={{ height: "65px", marginBottom: "20px" }}
          />
          <Alert severity="error" className="mb-20" sx={{maxWidth: '340px', whiteSpace: 'normal', wordBreak: 'break-word', overflowWrap: 'break-word'}}>
              {message}.
          </Alert>
          
          <Button variant="contained" startIcon={<ArrowBackIcon />} className="btn-clearfilter" onClick={() => redirectToHome()}  >
            Back to Sign In
          </Button>
        </Box>
      </HomeSignInSplashScreen>
    </>
  );
};

export default Error;
